module.exports = __webpack_public_path__ + "static/media/tournaments-active-menu-icon.2152dd20.svg";